<template>
  <div class="search">
    <el-row :gutter="24">
      <template v-if="!isDispatcherRole">
      <p>Поиск</p>
        <el-col :span="16">
          <search-input
            v-model="search_input"
            placeholder="Поиск по номеру Акта, номеру ТТН, номеру Авто"
            big
            @clear="clearFilter"
            @search="onSearch"
            @input="onInput"
          />
        </el-col>
      </template>
      <el-col :span="8">
        <div class="action-button">
          <img
            v-if="canAction('calcActions')"
            width="40"
            src="@/assets/img/calculator.png"
            class="calc"
            @click="goToCalc"
          />
          <el-button icon="el-icon-edit" circle @click="goToProfile()" />
          <el-button size="small" type="success" circle @click="logOut()">
            <img src="@/assets/img/logout.svg" />
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SearchInput from '@/components/Shared/SearchInput'

export default {
  name: 'HeaderSearch',
  components: { SearchInput },
  data() {
    return {
      search_input: '',
    }
  },
  methods: {
    onInput(cur) {
      this.search_input = cur
    },
    clearFilter() {
      this.search_input = ''
      this.getFlightsList()
    },
    getFlightsList(search = '') {
      const path = search ? `/flights?search=${search}` : '/flights'

      this.$router.push(path)
    },
    onSearch() {
      const filterValue = String(this.search_input).trim()

      this.getFlightsList(filterValue)
    },
    logOut() {
      this.$store.dispatch(`auth/authLogout`)
    },
    goToProfile() {
      this.$router.push({ path: '/user' })
    },
    goToCalc() {
      this.$router.push({ path: '/calculator' })
    },
  },
}
</script>

<style lang="sass">
.search
  p
    font-size: 14px
    line-height: 17px
    margin: 0  0 10px 0
    padding-left: 10px
  .action-button
    display: flex
    justify-content: flex-end
    .calc
      margin-right: 8px
      cursor: pointer
      &:hover
        opacity: 0.5
</style>
